import * as React from 'react';

import { cn, EditableDateField } from '@heartplus/ui';

import { parseIsoTokenDate, toIsoTokenDate } from './dates';
import { INLINE_TOKEN_CLASS, INLINE_TOKEN_DROPDOWN_WIDTH } from './styles';

type EditableDateTokenProps = {
  value: string;
  label: string;
  onValueChange: (nextValue: string) => void;
};

export const EditableDateToken: React.FC<EditableDateTokenProps> = ({
  value,
  label,
  onValueChange,
}) => {
  const parsedDate = parseIsoTokenDate(value);

  return (
    <EditableDateField
      value={parsedDate}
      onChange={(date) => onValueChange(toIsoTokenDate(date))}
      placeholder={label || 'Select date'}
      defaultEditable={false}
      openOnEdit
      fitContent
      className={cn(INLINE_TOKEN_CLASS, 'border', INLINE_TOKEN_DROPDOWN_WIDTH)}
      dateFormat="MM/dd/yyyy"
    />
  );
};
